import React from "react";
import axios from 'axios';
import {
    MDBStepper, MDBStep, MDBBtn, MDBAnimation, toast, ToastContainer, MDBCardText, MDBCard, MDBCardTitle, MDBSelect,
    MDBRow, MDBCol, MDBIcon, MDBInput, MDBInputGroup, MDBContainer, MDBBadge, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter
} from "mdbreact";
import AsyncSelect from 'react-select/async';
import Header from './ComponentFragments/Header';
import DataLayer from '../Utilities/DataLayer';
import Formatter from '../Utilities/Formatter';
import Colors from '../Styles/Colors';
import TopSeller from './ComponentFragments/TopSeller';
import SelectSearch from 'react-select-search';
import ReactToPrint from 'react-to-print';


export default class TestPage extends React.Component {

    constructor(props) {
        super(props);
        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));
        this.state = {
            formActivePanel1: 1,
            formActivePanel1Changed: false,
            cartData: {
                cartItems: []
            },
            dirty: false,
            hotItems: [],
            deliveryOptions: [],
            deliveryCharges: [],
            filteredCharges: [],
            provinces: [],
            selectedSuburb: '',
            selectedProvince: '',
            selectedDeliveryOption: 0,
            selectedDeliveryCharge: 0,
            specialsItems: [],
            specialsItemsDisplay: [],
            isExperienceCenter: false,
            hasOrder: false,
            orderNo: '-1',
            modalOpen: false,
            //cartModalOpen: false,
            acceptedTerms: "false",
            disabled: true,
            fastwayFormHidden: true,
            courierCharge: 0,
            fname: '',
            lname: '',
            deliveryApartment: '',
            deliveryStreet: '',
            summaryVisible: true,
            deliveryPhone: '',
            deliveryInstructions: '',
            formModalOpen: false,
            modalMsg: ''
        }
        this.formatter = new Formatter();
        this.dl = new DataLayer();
        this.handleChange = this.handleChange.bind(this);
        this.zeroItem = this.zeroItem.bind(this);
        this.setQty = this.setQty.bind(this);
        this.checkout = this.checkout.bind(this);
        this.resetCart = this.resetCart.bind(this);
        this.updateCart = this.updateCart.bind(this);
        this.filterCharges = this.filterCharges.bind(this);
        this.addSpecial = this.addSpecial.bind(this);
        this.getDeliveryOptionsDisplay = this.getDeliveryOptionsDisplay.bind(this);
        this.getCartButtons = this.getCartButtons.bind(this);
        this.payNow = this.payNow.bind(this);
        this.payNowMiGS = this.payNowMiGS.bind(this);
        this.successFn = this.successFn.bind(this);
        this.failureFn = this.failureFn.bind(this);
        this.processPaymentResult = this.processPaymentResult.bind(this);
        this.toggle = this.toggle.bind(this);
        this.toggleCartModal = this.toggleCartModal.bind(this);
        this.toggleFormModal = this.toggleFormModal.bind(this);
        this.changeHandler = this.changeHandler.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    toggleFormModal() {
        this.setState({
            formModalOpen: !this.state.formModalOpen
        })
    }

    async toggleCartModal() {
        this.setState({
            dirty: !this.state.dirty
        });

    }

    async toggle() {
        this.setState({
            modalOpen: !this.state.modalOpen
        });
        let ssfCartId = this.state.cartData.cartItems[0].cartId;
        let amnt = (parseFloat(this.state.cartData.orderTotal.toFixed(2)) * 1);
        amnt = amnt * 10;
        amnt = amnt * 10;

        let fastwayDeliveryDetail = {
            fname: this.state.fname,
            lname: this.state.lname,
            deliveryApartment:this.state.deliveryApartment,
            deliveryStreet: this.state.deliveryStreet,
            deliveryPhone: this.state.deliveryPhone,
            deliveryInstructions: this.state.deliveryInstructions,
            selectedSuburb: this.state.selectedSuburb.value,
            selectedProvince: this.state.selectedProvince
        }

        let requestObject = {
            amount: amnt,
            deliveryOption: this.state.selectedDeliveryCharge,
            merchantReference: this.state.cartData.cartItems[0].cartId,
            SSFCartId: ssfCartId,
            courierCharge: this.state.courierCharge * 1,
            fastwayDeliveryDetail: fastwayDeliveryDetail
        }
        let response = await this.dl.Post("/shop/paynow", requestObject, false);
        if (!response.errorOccurred) {
            this.setState({
                paymentRequestId: response.data.requestId
            })
            window.hpp.payment(response.data, this.successFn, this.failureFn);
        } else {
            if (response.otherInfo == 'EC01') {
                this.setState({
                    errorModalOpen: true,
                    cartErrorMsg: response.errorMessage
                });
            } else {
                alert("Oops, something seems to have gone wrong. Please log out and back in to try again.");
            }
        }
    }

    async successFn(response) {
        this.processPaymentResult(response, true);
        //console.dir(response);
    }

    async failureFn(response) {
        this.processPaymentResult(response, false);
        //console.dir(response);
    }

    async processPaymentResult(response, success) {
        let ssfCartId = this.state.cartData.cartItems[0].cartId;
        let amnt = (parseFloat(this.state.cartData.orderTotal.toFixed(2)) * 1);
        amnt = amnt * 10;
        amnt = amnt * 10;

        //let testResponse = ({
        //    MerchantReference: "",
        //    Result: "Success",
        //    FailureMessage: "",
        //    Amount: 12000,
        //    CheckSum:"0A05BB5FCD9D6567F9F78B4C12FdjdjjlE635B24B629A2E742963893E0BC1787D769" use an existing checksum to check response does not get written twice.
        //});
        let paymentResponse = {
            response: response, //testResponse
            SSFCartId: ssfCartId
        };
        let resp = await this.dl.Post("/shop/PaymentResult", paymentResponse);
        if (resp.data) {
            if (success) {
                let resp = await this.checkout();
                if (!resp.error) {
                    let invResponse = await this.dl.Get("/shop/WriteInvoice/" + resp.orderId + "/" + amnt + "/" + response.MerchantReference);
                    toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; Invoiced & Receipted Successfully </span>, {
                        closeButton: false
                    });
                }
            }
        }
    }

    async payNowMiGS() {
        let amnt = (parseFloat(this.state.cartData.orderTotal.toFixed(2)) * 1);
        amnt = amnt * 10;
        amnt = amnt * 10;
        let requestObject = {
            amount: amnt,
            merchantReference: this.state.cartData.cartItems[0].cartId,
            deliveryOption: this.state.selectedDeliveryCharge
        }
        let response = await this.dl.Post("/shop/GetRedirectUrl", requestObject);
        let tester = "";
        window.location.assign(response.data);
    }


    async payNow() {
        this.setState({
            modalOpen: !this.state.modalOpen
        });
        //*********** put back after test
        //let amnt = (parseFloat(this.state.cartData.orderTotal.toFixed(2)) * 1);
        //amnt = amnt * 10;
        //amnt = amnt * 10;
        //let requestObject = {
        //    amount: amnt,
        //    merchantReference: this.state.cartData.cartItems[0].cartId
        //}
        //let response = await this.dl.Post("/shop/paynow", requestObject);
        //window.hpp.payment(response.data, this.successFn, this.failureFn);
        ///////////////*****************************************************
        //this.processPaymentResult(null, true); use this to test with
    }

    async addSpecial(specialItem) {
        this.props.loaderOn();
        let requestObject = {
            specialItem,
            cartItemList: this.state.cartData.cartItems,
            deliveryOption: this.state.selectedDeliveryCharge,
            isExperienceCenter: this.props.location.state === undefined ? false : true
        }
        let response = await this.dl.Post("/common/applyspecial", requestObject);
        var test = "";
        this.setState({
            cartData: response.data,
            dirty: false
        })
        this.updateCart();

    }

    async componentWillMount() {
        //this.props.loaderOn();
        //alert(this.TMAUser.data.useOnlinePayments);
        //let response = await this.dl.Get("/common/getcart/" + (this.props.location.state === undefined ? false : true));
        //let hotItems = await this.dl.Get("/common/gethotitems"); in case we want to put top sellers back
        let deliveryCharges = await this.dl.Get("/common/getdeliveryoptions");

        let specialsItems = await this.dl.Get("/common/getspecialsitems/" + (this.props.location.state === undefined ? false : true));

        let result = await this.dl.Get('/common/getProvincesAndTowns', 200);

        let defaultDelivery = deliveryCharges.data.filter((item) => item.isDefault === true);

        let deliveryOptions = [];
        if (deliveryCharges.data.some(e => e.dispatchType === 1)) {
            deliveryOptions.push({ name: "Collect", value: 1 })
        }

        if (deliveryCharges.data.some(e => e.dispatchType === 2)) {
            deliveryOptions.push({ name: "Deliver", value: 2 })
        }

        //can refactor *********************************************
        //let cartItemData = response.data.cartItems;
        //let specialsItemsDisplay = Array.from(specialsItems.data);
        //cartItemData.forEach((item) => {
        //    let sIndex = specialsItemsDisplay.findIndex((sItem) => sItem.getProcessingCode === item.processingCode);
        //    if (sIndex != -1) {
        //        specialsItemsDisplay.splice(sIndex, 1);
        //    }
        //})

        //if (response.data.discountValue > 0) {
        //    //remove any discount type specials

        //}

        //*************************************************************
        let defaultProvince = "";
        result.data.provinceList.forEach((prov) => {
            if (prov.checked) {
                defaultProvince = prov.text.trim();
            }
        })

        this.setState({
            selectedProvince: defaultProvince,
            provinces: result.data.provinceList,
            //cartData: response.data,
            deliveryCharges: deliveryCharges.data,
            specialsItems: specialsItems.data,
            isExperienceCenter: this.props.location.state === undefined ? false : true,
            hasOrder: this.props.location.state === undefined ? false : this.props.location.state.hasOrder ? true : false,
            orderNo: this.props.location.state === undefined ? '-1' : this.props.location.state.orderNo,
            deliveryOptions
        })

        this.filterCharges(defaultDelivery[0].dispatchType);
        //this.props.loaderOff()
    }

    filterCharges(dispatchType) {
        let items = this.state.deliveryCharges.filter((item) => item.dispatchType === dispatchType);
        let filteredCharges = [];
        items.forEach((item) => {
            filteredCharges.push({ name: item.description, value: item })
        })
        this.setState({
            filteredCharges,
            selectedDeliveryOption: dispatchType,
            selectedDeliveryCharge: items[0]
        })
        this.updateCart();
    }

    async updateCart() {
        this.props.loaderOn();
        if (this.state.cartData.cartItems.length > 0) {
            let requestObject = {
                cartItemList: this.state.cartData.cartItems,
                deliveryOption: this.state.selectedDeliveryCharge,
                isExperienceCenter: this.props.location.state === undefined ? false : true,
                courierCharge: this.state.courierCharge
            }

            let response = await this.dl.Post("/common/updatecart", requestObject);
            let specialsItems = await this.dl.Get("/common/getspecialsitems/" + (this.props.location.state === undefined ? false : true));
            let test = "";
            // can refactor *********************************************
            let cartItemData = response.data.cartItems;
            let specialsItemsDisplay = Array.from(specialsItems.data);
            cartItemData.forEach((item) => {
                let sIndex = specialsItemsDisplay.findIndex((sItem) => sItem.getProcessingCode === item.processingCode);
                if (sIndex != -1) {
                    specialsItemsDisplay.splice(sIndex, 1);
                }
            })

            if (response.data.discountValue > 0) {
                //remove any discount type specials
                specialsItemsDisplay.forEach((item, index) => {
                    if (item.outcomeType === "Or") {
                        specialsItemsDisplay.splice(index, 1);
                    }
                })
            }

            //***********************************************************
            this.props.updateCartCount(response.data.cartItems.length);
            this.setState({
                cartData: response.data,
                specialsItems: specialsItems.data,
                specialsItemsDisplay,
                dirty: false
            })
        }
        this.props.loaderOff();
    }

    resetCart() {
        let cartData = this.state.cartData;

        cartData.cartItems.forEach((item) => item.qty = item.originalQty);

        this.setState({
            cartData,
            dirty: false
        })
    }

    zeroItem(item) {
        this.setQty(0, item);
    }

    setQty(qty, item) {
        let cartData = this.state.cartData
        let index = -1;
        if (item.stockId != 0) {
            index = cartData.cartItems.findIndex((i) =>
                i.stockId == item.stockId
            );

        } else {
            index = cartData.cartItems.findIndex((i) =>
                i.shipStockId == item.shipStockId
            );
        }
        cartData.cartItems[index].qty = qty

        let changedItems = cartData.cartItems.some((i) => i.qty != i.originalQty);

        this.setState({
            cartData,
            dirty: changedItems,
            cartModalOpen: changedItems
        })
    }

    handleChange(event, item) {
        let qty = event.target.valueAsNumber

        let specialsItems = this.state.specialsItems;

        let special = this.state.specialsItems.find((sItem) => sItem.getProcessingCode === item.processingCode);
        if (special !== undefined) {
            if (qty > special.maxAllowed) {
                qty = special.maxAllowed;
            }
        }

        if (qty < 0) {
            qty = 1;
        }
        this.setQty(qty, item);
    }

    async checkout() {


        this.props.loaderOn();
        let fastwayDeliveryDetail = {
            fname: this.state.fname,
            lname: this.state.lname,
            deliveryApartment: this.state.deliveryApartment,
            deliveryStreet: this.state.deliveryStreet,
            deliveryPhone: this.state.deliveryPhone,
            deliveryInstructions: this.state.deliveryInstructions,
            selectedSuburb: this.state.selectedSuburb.value,
            selectedProvince: this.state.selectedProvince
        }
        let requestObject = {
            cartItemList: this.state.cartData.cartItems,
            deliveryOption: this.state.selectedDeliveryCharge,
            isExperienceCenter: this.props.location.state === undefined ? false : true,
            courierCharge: this.state.courierCharge,
            fastwayDeliveryDetail: fastwayDeliveryDetail
        }

        let response = await this.dl.Post("/common/checkout", requestObject);
        if (!response.errorOccurred) {
            if (!this.state.isExperienceCenter) {
                this.setState({
                    cartData: {
                        cartItems: []
                    }
                })
                this.props.updateCartCount(0);
                toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; Order generated successfully. </span>, {
                    closeButton: false
                });
            } else {
                this.setState({
                    hasOrder: true,
                    orderNo: response.data
                });
                toast.success(<span style={{ paddingLeft: "15px", fontSize: "18px" }}><MDBIcon icon="check-circle" />&nbsp;&nbsp; Checkout code generated successfully. </span>, {
                    closeButton: false
                });
            }
            let resp = {
                error: false,
                orderId: response.data
            }
            this.props.loaderOff();
            return resp;
        } else {
            let resp = {
                error: true,
                orderId: -1
            }
            this.props.loaderOff();
            return resp;
        }



    }

    changeHandler(value) {
        if (value == "false") {
            let test = value;
            this.setState({
                acceptedTerms: "true",
                disabled: false
            })
        } else {
            let sjdsk = value;
            this.setState({
                acceptedTerms: "false",
                disabled: true
            })
        }

        //alert(this.state.acceptedTerms);
    };

    getCartButtons(isExperienceCenter, disableEcCheckout) {
        if (isExperienceCenter) {
            return (
                <MDBCol sm="12" className="text-center">
                    <div hidden={!this.state.dirty}>
                        <MDBBtn rounded color="mdb-color" size="sm" onClick={this.resetCart}><MDBIcon icon="sync-alt" />&nbsp;Reset</MDBBtn>
                        <MDBBtn rounded color="pink" size="sm" onClick={this.updateCart}><MDBIcon icon="arrow-up" />&nbsp;Update</MDBBtn><br />
                        <span style={{ color: "black", fontSize: "14px" }}>Cart has changed, please update to checkout. <br />(Items with 0 quantity will be removed.)</span>
                    </div>
                    <MDBBtn rounded disabled={disableEcCheckout} hidden={this.state.dirty} color="purple" size="sm" onClick={this.checkout}><MDBIcon icon="shopping-cart" />&nbsp;Generate Checkout Code</MDBBtn>
                </MDBCol>
            )
        } else {
            return (
                <MDBCol sm="12" className="text-center">
                    <div hidden={!this.state.dirty}>
                        <MDBBtn rounded color="mdb-color" size="sm" onClick={this.resetCart}><MDBIcon icon="sync-alt" />&nbsp;Reset</MDBBtn>
                        <MDBBtn rounded color="pink" size="sm" onClick={this.updateCart}><MDBIcon icon="arrow-up" />&nbsp;Update</MDBBtn><br />
                        <span style={{ color: "black", fontSize: "14px" }}>Cart has changed, please update to checkout. <br />(Items with 0 quantity will be removed.)</span>
                    </div>
                    <MDBBtn rounded className="float-left" color="purple" size="sm" onClick={this.handleNextPrevClick(1)(3)}>Previous</MDBBtn>
                    <MDBBtn rounded className="float-right" disabled={this.state.cartData.cartItems.length == 0} hidden={this.state.dirty} color="purple" size="sm" onClick={this.checkout}><MDBIcon icon="shopping-cart" />&nbsp;Checkout<br /> (Pay Via EFT/Bank Dposit<br />Send Proof Within 24Hrs)</MDBBtn>
                    {this.TMAUser.data.useOnlinePayments ? this.TMAUser.data.bankAccountId == -1 ? (<div></div>) :
                        (
                            this.TMAUser.data.paymentGatewayId == 1 ?
                                (
                                    <MDBBtn rounded className="float-right" disabled={this.state.cartData.cartItems.length == 0} hidden={this.state.dirty} color="purple" size="sm" onClick={this.payNow}><MDBIcon icon="shopping-cart" />&nbsp;Checkout<br /> (Pay Now With<br /> Debit/Credit Card)</MDBBtn>
                                )
                                :
                                (
                                    <div hidden={this.state.dirty}>
                                        <MDBBtn rounded className="float-right" disabled={this.state.cartData.cartItems.length == 0 || this.state.disabled} color="purple" size="sm" onClick={this.payNowMiGS}><MDBIcon icon="shopping-cart" />&nbsp;Checkout<br /> (Pay Now With<br /> Debit/Credit Card)</MDBBtn>

                                        {/*<MDBInput getValue={this.changeHandler} value={this.state.acceptedTerms} label="I accept the Terms and Conditions" type="checkbox" name="acceptedTerms" id="acceptedTerms" />*/}
                                    </div>
                                )

                        ) : (
                            <div></div>
                        )}
                </MDBCol>
            )
        }
    }

    getDeliveryOptionsDisplay(isExperienceCenter) {
        if (isExperienceCenter) {
            return (<div></div>)
        } else {
            return (
                <div>

                    <MDBCardText>
                        <SelectSearch
                            options={this.state.deliveryOptions}
                            placeholder="Delivery Option"
                            value={this.state.selectedDeliveryOption}
                            search={false}
                            onChange={(selectedItem) => {
                                this.filterCharges(selectedItem.value)
                                let FastWayHidden = selectedItem.value.fastwayDelivery ? false : true
                                this.setState({
                                    fastwayFormHidden: FastWayHidden
                                })
                            }}
                        />
                        <SelectSearch
                            options={this.state.filteredCharges}
                            placeholder="Delivery Charge"
                            value={this.state.selectedDeliveryCharge}
                            search={false}
                            onChange={(selectedItem) => {
                                let FastWayHidden = selectedItem.value.fastwayDelivery ? false : true
                                this.setState({
                                    selectedDeliveryCharge: selectedItem.value,
                                    fastwayFormHidden: FastWayHidden
                                })
                                this.updateCart();
                            }}
                        />
                        <div hidden={this.state.fastwayFormHidden}>
                            <MDBRow>

                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.fname}
                                        name="fname"
                                        onChange={this.fieldChangeHandler}
                                        type="text"
                                        id="fname"
                                        label="First Name (Required)"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="6">
                                    <MDBInput
                                        value={this.state.lname}
                                        name="lname"
                                        onChange={this.fieldChangeHandler}
                                        type="text"
                                        id="lname"
                                        label="Surname (Required)"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="12">
                                    <MDBSelect
                                        label="Select Province"
                                        options={this.state.provinces}
                                        selected="Province"
                                        getValue={this.handleSelectChange}
                                        required
                                        value={this.state.selectedProvince}
                                    />
                                </MDBCol>
                                <MDBCol md="6">
                                    <AsyncSelect
                                        value={this.state.selectedSuburb}
                                        onChange={this.onSuburbChange}
                                        placeholder="Search Suburbs"
                                        loadOptions={this.loadSuburbs}
                                    />
                                </MDBCol>
                                <MDBCol md="6">
                                    <span style={{ marginTop: "10px" }}>Courier Charge:&nbsp;{this.state.courierCharge}</span>
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                <MDBCol md="12">
                                    <MDBInput
                                        value={this.state.deliveryStreet}
                                        name="deliveryStreet"
                                        onChange={this.fieldChangeHandler}
                                        type="text"
                                        id="deliveryStreet"
                                        label="House Number and Street Name (Required)"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="12">
                                    <MDBInput
                                        value={this.state.deliveryApartment}
                                        name="deliveryApartment"
                                        onChange={this.fieldChangeHandler}
                                        type="text"
                                        id="deliveryApartment"
                                        label="Apartment, suite, unit, etc (Optional)"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="12">
                                    <MDBInput
                                        value={this.state.deliveryPhone}
                                        name="deliveryPhone"
                                        onChange={this.fieldChangeHandler}
                                        type="text"
                                        id="deliveryPhone"
                                        label="Phone Number (Required)"
                                        required
                                    >

                                    </MDBInput>
                                </MDBCol>
                                <MDBCol md="12">
                                    <MDBInput type="textarea"
                                        label="Message/Special Instructions (Optional)"
                                        name="deliveryInstructions"
                                        value={this.state.deliveryInstructions}
                                        id="deliveryInstructions"
                                        onChange={this.fieldChangeHandler}
                                        rows="5" />
                                </MDBCol>
                            </MDBRow>
                        </div>
                    </MDBCardText>
                </div>
            )
        }
    }

    fieldChangeHandler = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    async handleSelectChange(selected) {
        if (selected.length > 0) {
            let prov = this.state.provinces.filter((item) => (item.value == selected))
            this.setState({
                selectedProvince: prov[0].text.trim(),
                selectedSuburb: '',
                courierCharge: 0.00
            });
        }
    }

    loadSuburbs = async (inputText, callback) => {
        let province = this.state.selectedProvince.toUpperCase();
        province = province.replace(/ /g, '');
        const response = await axios.get(`https://api.siteway.co.za/fastway/woo/v1/find-suburb-province-all/?query=${inputText}`);
        const json = response.data;
        let suburbs = [];
        json.forEach((item) => {
            var str = item.value;
            var res = str.split("(");
            var provPart = res[1];
            provPart = provPart.split("-");//[0].trim().toUpperCase();
            var provincePart = "";

            if (provPart.length > 1) {
                var count = provPart.length - 1;
                for (var i = 0; i < count; i++) {
                    provincePart += provPart[i].toUpperCase();
                }
            } else {
                provincePart = provPart[0].trim().toUpperCase();
            }
            provincePart = provincePart.replace(/ /g, '');
            provincePart = provincePart.replace(/-/g, '');
            if (provincePart == province) {
                suburbs.push(item);
            }
        });
        callback(suburbs.map(item => ({ label: item.text, value: item.value })));
    }

    onSuburbChange = selSuburb => {
        this.setState({
            selectedSuburb: selSuburb
        })
        this.calculateDelivery(selSuburb);
    }

    async calculateDelivery(suburb) {
        this.props.loaderOn();
        let franchiseCode = this.state.selectedDeliveryCharge.fastwayFranchiseCode
        var str = suburb.value;
        var res = str.split("(");
        var suburbPart = res[0].trim();
        var codePart = res[1]
        codePart = codePart.split("-")[1].trim();
        codePart = codePart.split(")")[0];
        let priceResponse = await axios.get(`https://sa.api.fastway.org/v3/psc/lookup/${franchiseCode}/${suburbPart}/${codePart}/5?api_key=54b545010fd070c89cd5e0aa2646769e`);
        let services = priceResponse.data.result.services;
        let price = 0.00;
        services.forEach((service) => {
            if (service.type.trim().toUpperCase() == "PARCEL") {
                if (price == 0) {
                    price = service.totalprice_frequent_exgst * 1;
                } else {
                    if ((service.totalprice_frequent_exgst * 1) < price) {
                        price = service.totalprice_frequent_exgst * 1;
                    }
                }
            }
        });
        this.setState({
            courierCharge: price.toFixed(2)
        })
        this.updateCart();
        //this.props.loaderOff();
    }

    swapFormActive = (a) => (param) => (e) => {
        var showSummary = true;
        if (param == 4) {
            showSummary = false;
        } else {
            showSummary = true;
        }

        var goNext = true;
        if (this.state.lname == '') {
            goNext = false;
        }
        if (this.state.fname == '') {
            goNext = false;
        }
        if (this.state.selectedSuburb == '') {
            goNext = false;
        }
        if (this.state.selectedProvince == '') {
            goNext = false;
        }
        if (this.state.deliveryStreet == '') {
            goNext = false;
        }
        if (this.state.deliveryPhone == '') {
            goNext = false;
        }

        if ((param > 2) && !this.state.fastwayFormHidden) {
            if (param == 4) {
                if (this.state.acceptedTerms == "true" && goNext) {
                    this.setState({
                        ['formActivePanel' + a]: param,
                        ['formActivePanel' + a + 'Changed']: true,
                        summaryVisible: showSummary
                    });
                } else if (!goNext) {
                    this.setState({
                        formModalOpen: true,
                        modalMsg: 'Please fill out all required fields before moving on.'
                    })
                } else {
                    this.setState({
                        formModalOpen: true,
                        modalMsg: 'Please accept Terms and Conditions before moving on.'
                    })
                }
            } else if (goNext) {
                //if (this.state.acceptedTerms == "true") {
                    this.setState({
                        ['formActivePanel' + a]: param,
                        ['formActivePanel' + a + 'Changed']: true,
                        summaryVisible: showSummary
                    });
                //}
            } else {
                this.setState({
                    formModalOpen: true,
                    modalMsg: 'Please fill out all required fields before moving on.'
                })
            }

        } else if (param == 4) {
            if (this.state.acceptedTerms == "true") {
                this.setState({
                    ['formActivePanel' + a]: param,
                    ['formActivePanel' + a + 'Changed']: true,
                    summaryVisible: showSummary
                });
            } else {
                this.setState({
                    formModalOpen: true,
                    modalMsg: 'Please accept Terms and Conditions before moving on.'
                })
            }
        } else {
            this.setState({
                ['formActivePanel' + a]: param,
                ['formActivePanel' + a + 'Changed']: true,
                summaryVisible: showSummary
            });

        }
    }

    handleNextPrevClick = (a) => (param) => (e) => {
        var showSummary = true;
        var goNext = true;
        if (this.state.lname == '') {
            goNext = false;
        }
        if (this.state.fname == '') {
            goNext = false;
        }
        if (this.state.selectedSuburb == '') {
            goNext = false;
        }
        if (this.state.selectedProvince == '') {
            goNext = false;
        }
        if (this.state.deliveryStreet == '') {
            goNext = false;
        }
        if (this.state.deliveryPhone == '') {
            goNext = false;
        }
        if (param == 4) {
            showSummary = false;
        } else {
            showSummary = true;
        }

        if (param == 3 && !this.state.fastwayFormHidden) {
            if (goNext) {
                this.setState({
                    ['formActivePanel' + a]: param,
                    ['formActivePanel' + a + 'Changed']: true,
                    summaryVisible: showSummary
                });
            } else {
                this.setState({
                    formModalOpen: true,
                    modalMsg: 'Please fill out all required fields before moving on.'
                })
            }
        } else {
            this.setState({
                ['formActivePanel' + a]: param,
                ['formActivePanel' + a + 'Changed']: true,
                summaryVisible: showSummary
            });
        }
    }

    handleSubmission = () => {
        alert('Form submitted!');
    }

    calculateAutofocus = (a) => {
        if (this.state['formActivePanel' + a + 'Changed']) {
            return true
        }
    }

    render() {
        let cartId = this.state.cartData.cartItems.length > 0 ? this.state.cartData.cartItems[0].cartId : '';
        let headerText = this.state.isExperienceCenter ? "Experience Center Express Checkout" : "Shopping Cart";
        let disableEcCheckout = false;
        if (this.state.cartData.cartItems.length == 0 || this.state.hasOrder) {
            disableEcCheckout = true
        }
        return (


            <div>
                <MDBRow>
                    <MDBCol md="12">
                        <MDBStepper icon>
                            <MDBStep far icon="shopping-cart" stepName="Cart Detail" onClick={this.swapFormActive(1)(1)}></MDBStep>
                            <MDBStep icon="truck" stepName="Delivery/Collection Detail" onClick={this.swapFormActive(1)(2)}></MDBStep>
                            <MDBStep icon="file-signature" stepName="Terms and Conditions" onClick={this.swapFormActive(1)(3)}></MDBStep>
                            <MDBStep icon="cash-register" stepName="Finish" onClick={this.swapFormActive(1)(4)}></MDBStep>
                        </MDBStepper>
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    <MDBCol xl="8" lg="7" md="12">
                        <form role="form" action="" method="post">

                            {this.state.formActivePanel1 == 1 &&
                                (<MDBCol md="12">
                                    <span style={{ fontSize: "16px", fontWeight: "bold", paddingTop: "3px" }}>Cart Detail</span>
                                    {
                                        this.state.specialsItemsDisplay.length > 0 ? (
                                            <div>

                                                <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                                    <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>
                                                        <MDBIcon icon="fire-alt" className="red-text" />&nbsp;You Qualify For The Following {this.state.specialsItems.length === 1 ? "Special" : "Specials"}
                                                    </MDBCardTitle>
                                                    <hr className="hr_grey" />
                                                    {this.state.specialsItemsDisplay.map((item) => {

                                                        return (
                                                            item.outcomeType == "Or" ? <MDBCardText>
                                                                <MDBRow className="mx-2" between>
                                                                    <MDBCol md="6" sm="12"><span style={{ color: Colors.purple, fontWeight: "bold" }}>{item.description}</span><br />
                                                                        <MDBRow>
                                                                            <MDBCol>
                                                                                <span style={{ fontSize: "14px" }}>Description: {item.otherItemDescription}</span>

                                                                            </MDBCol>
                                                                            <MDBCol className="text-right">
                                                                                <span style={{ fontSize: "14px" }}>Amount: {item.otherType === "Value" ? this.formatter.formatCurrency(item.otherItemValue) + " Off" : item.otherItemValue + "% Off"} </span><br />

                                                                            </MDBCol>
                                                                        </MDBRow>

                                                                    </MDBCol>
                                                                    <MDBCol md="3" sm="12">
                                                                        <MDBBtn rounded color="purple" size="sm" onClick={() => this.addSpecial(item)}><MDBIcon icon="plus" />&nbsp;Apply</MDBBtn>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                                <hr className="hr_grey" />
                                                            </MDBCardText>
                                                                :
                                                                <MDBCardText>
                                                                    <MDBRow className="mx-2" between>
                                                                        <MDBCol md="6" sm="12"><span style={{ color: Colors.purple, fontWeight: "bold" }}>{item.description}</span><br />
                                                                            <MDBRow>
                                                                                <MDBCol>
                                                                                    <span style={{ fontSize: "14px" }}>Price: {this.formatter.formatCurrency(item.d)}</span><br />
                                                                                    <span style={{ fontSize: "14px" }}>Code: {item.buyProcessingCode === null ? item.getProcessingCode : item.buyProcessingCode}</span>
                                                                                </MDBCol>
                                                                                <MDBCol className="text-right">
                                                                                    <span style={{ fontSize: "14px" }}>Recognition: {this.formatter.formatCurrency(item.recognition)}</span><br />
                                                                                    <span style={{ fontSize: "14px", fontWeight: "bold" }}>Max Allowed: {item.maxAllowed}</span>
                                                                                </MDBCol>
                                                                            </MDBRow>

                                                                        </MDBCol>
                                                                        <MDBCol md="3" sm="12">
                                                                            <MDBBtn rounded color="purple" size="sm" onClick={() => this.addSpecial(item)}><MDBIcon icon="plus" />&nbsp;Add</MDBBtn>
                                                                        </MDBCol>
                                                                    </MDBRow>
                                                                    <hr className="hr_grey" />
                                                                </MDBCardText>

                                                        )
                                                    })}
                                                </MDBCard>

                                            </div>)
                                            : (<div></div>)


                                    }
                                    <MDBCard className="card-body" style={{ marginTop: "1rem" }}>
                                        <MDBRow>
                                            <MDBCol lg="6">
                                                <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}><MDBIcon icon="list-ul" />&nbsp;{this.state.isExperienceCenter ? 'Express Items' : 'Items In Your Cart'}&nbsp;<MDBBadge color="purple">{this.state.cartData.cartItems.length}</MDBBadge></MDBCardTitle>
                                            </MDBCol>
                                            <MDBCol lg="6" className="text-right">
                                                <MDBCardTitle style={{ textDecoration: "underline", fontSize: "16px", paddingBottom: "3px" }}>{this.state.hasOrder ? (<div>Your Checkout Code is : <span style={{ fontWeight: 'bold', color: 'red', fontSize: '20px' }}>{this.state.orderNo}</span></div>) : (<div></div>)}</MDBCardTitle>
                                            </MDBCol>
                                        </MDBRow>
                                        <hr className="hr_grey" />
                                        {
                                            this.state.cartData.cartItems.map((item, index) => {
                                                return (
                                                    <div key={index}>
                                                        <MDBRow className="mx-2" between>
                                                            {/*<MDBCol>
                                                    <img src="https://mdbootstrap.com/img/Others/documentation/1.jpg" className="img-fluid" alt="" />
                                                </MDBCol>*/}
                                                            <MDBCol sm="12">
                                                                {item.specialItem ? <span style={{ color: Colors.purple, fontWeight: "bold" }}><MDBIcon icon="fire-alt" className="red-text" />&nbsp;{item.invoiceDescription}</span> : <span style={{ color: Colors.purple, fontWeight: "bold" }}>{item.invoiceDescription}</span>}
                                                                <br />
                                                            </MDBCol>
                                                            <MDBCol md="6" sm="12">
                                                                <MDBRow>
                                                                    <MDBCol>
                                                                        <span style={{ fontSize: "14px" }}>Code: {item.processingCode}</span><br />
                                                                        <span style={{ fontSize: "14px" }}>Retail: {this.formatter.formatCurrency(item.retail / 100)}</span>
                                                                    </MDBCol>
                                                                    <MDBCol className="text-right">
                                                                        <span style={{ fontSize: "14px" }}>Price: {this.formatter.formatCurrency(item.price / 100)}</span><br />
                                                                        <span style={{ fontSize: "14px", fontWeight: "bold" }}>Total: {this.formatter.formatCurrency((item.price * item.qty) / 100)}</span>
                                                                    </MDBCol>
                                                                </MDBRow>
                                                                <span className="cartRemoveItem" onClick={() => this.zeroItem(item)}><MDBIcon far icon="trash-alt" /> Remove Item</span>
                                                            </MDBCol>
                                                            <MDBCol md="3" sm="12">
                                                                <MDBInput disabled={disableEcCheckout} className="mb-0" type="number" label="Qty" value={item.qty} min={0} onChange={(event) => this.handleChange(event, item)} />
                                                            </MDBCol>
                                                        </MDBRow><hr className="hr_grey" />

                                                    </div>
                                                );
                                            })
                                        }
                                        <MDBRow>
                                            <MDBCol>
                                                <MDBBtn rounded className="float-right" color="purple" size="sm" onClick={this.handleNextPrevClick(1)(2)}>next</MDBBtn>
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBCard>

                                </MDBCol>)}

                            {this.state.formActivePanel1 == 2 &&
                                (<MDBCol md="12">
                                    <span style={{ fontSize: "16px", fontWeight: "bold", paddingTop: "3px" }}>Delivery/Collection Options</span>

                                    <MDBCard className="card-body" style={{ marginTop: "1rem", marginTop: "1rem", color: this.state.dirty ? "#bdbdbf" : Colors.black }}>
                                        {this.getDeliveryOptionsDisplay(this.state.isExperienceCenter)}
                                        <hr className="hr_grey" />
                                        <MDBRow>
                                            <MDBCol>
                                                <MDBBtn rounded className="float-left" color="purple" size="sm" onClick={this.handleNextPrevClick(1)(1)}>previous</MDBBtn>
                                                <MDBBtn rounded className="float-right" color="purple" size="sm" onClick={this.handleNextPrevClick(1)(3)}>next</MDBBtn>
                                            </MDBCol>
                                        </MDBRow>
                                    </MDBCard>

                                </MDBCol>)}

                            {this.state.formActivePanel1 == 3 &&
                                (<MDBCol md="12">
                                    <p><span style={{ fontSize: "16px", fontWeight: "bold", paddingTop: "3px" }}>Terms and conditions</span></p>
                                    <MDBCard className="card-body" style={{ marginTop: "1rem", marginTop: "1rem", color: this.state.dirty ? "#bdbdbf" : Colors.black }}>
                                        <MDBCardText>
                                            <p>Read the Terms and Conditions <a target="_blank" href="http://mobi.tupperwaresa.co.za/termsandconditions.html"><MDBIcon far icon="file-alt" />&nbsp;here. </a></p>

                                            <MDBInput checked={this.state.acceptedTerms == "true" ? true : false} getValue={this.changeHandler} value={this.state.acceptedTerms} autoFocus={this.calculateAutofocus(1)} label="I accept the Terms and Conditions" type="checkbox" name="acceptedTerms" id="acceptedTerms" />
                                        </MDBCardText>
                                        <hr className="hr_grey" />
                                        <MDBRow>
                                            <MDBCol>
                                                <MDBBtn rounded className="float-left" color="purple" size="sm" onClick={this.handleNextPrevClick(1)(2)}>previous</MDBBtn>
                                                <MDBBtn disabled={this.state.disabled} rounded className="float-right" color="purple" size="sm" onClick={this.handleNextPrevClick(1)(4)}>next</MDBBtn>
                                            </MDBCol>
                                        </MDBRow>

                                    </MDBCard>



                                </MDBCol>)}

                            {this.state.formActivePanel1 == 4 &&
                                (<MDBCol md="12">
                                    <span style={{ fontSize: "16px", fontWeight: "bold", paddingTop: "3px" }}>Checkout</span>
                                    <MDBCard className="card-body" style={{ marginTop: "1rem", color: Colors.black }}>

                                        <MDBCardText>
                                            <MDBRow>
                                                <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                                    <div className="cartSummaryItem">Items Total:</div>
                                                    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.itemsTotal)}</div>
                                                </MDBCol>
                                                <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                                    <div className="cartSummaryItem">Delivery Charge:</div>
                                                    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.deliveryCharge)}</div>
                                                </MDBCol>
                                                <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                                    <div className="cartSummaryItem"> Fixed Charge:</div>
                                                    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.fixedCharge)}</div>
                                                </MDBCol>
                                                <MDBCol sm="12">
                                                    <hr className="hr_grey" />
                                                </MDBCol>
                                                <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                                                    <div className="cartSummaryItem">Sub Total:</div>
                                                    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.subTotal)}</div>
                                                </MDBCol>
                                                <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                                    <div className="cartSummaryItem">VAT:</div>
                                                    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.vat)}</div>
                                                </MDBCol>
                                                <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                                    <div className="cartSummaryItem">Rounding:</div>
                                                    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.rounding)}</div>
                                                </MDBCol>
                                                <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                                    <MDBIcon icon="fire-alt" className="red-text" />&nbsp;<div className="cartSummaryItem">Discount:</div>
                                                    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.discountValue)}</div>
                                                </MDBCol>
                                                <MDBCol sm="12">
                                                    <hr className="hr_grey" />
                                                </MDBCol>
                                                <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                                                    <div className="cartSummaryItem">Order Total:</div>
                                                    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.orderTotal)}</div>
                                                </MDBCol>
                                                <MDBCol sm="12" style={{ display: "table", fontWeight: "bold" }}>
                                                    <div className="cartSummaryItem">Recognition Total:</div>
                                                    <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.recognitionTotal)}</div>
                                                </MDBCol>
                                                <MDBCol sm="12">
                                                    <hr className="hr_grey" />
                                                </MDBCol>
                                                <MDBCol sm="12">
                                                    <span style={{ fontSize: "16px", fontWeight: "bold", paddingBottom: "3px" }}><MDBIcon icon="truck" />&nbsp;Delivery Detail</span>
                                                </MDBCol>
                                                <MDBCol md="12" style={{ fontSize: "14px", display: "table" }}>
                                                    <div className="cartSummaryItem"><b>Type:</b> {this.state.selectedDeliveryCharge.dispatchType == 1 ? ('Collect') : ('Deliver')}</div>
                                                </MDBCol>
                                                <MDBCol md="12" style={{ fontSize: "14px", display: "table" }}>
                                                    <div className="cartSummaryItem"><b>Method:</b> {this.state.selectedDeliveryCharge.description}</div>
                                                </MDBCol>
                                                {this.state.selectedDeliveryCharge.fastwayDelivery ? (
                                                    <div>
                                                        <MDBCol md="12" style={{ fontSize: "14px", display: "table" }}>
                                                            <div className="cartSummaryItem"><b>Deliver to:</b> {this.state.fname}&nbsp;{this.state.lname}</div>

                                                        </MDBCol>
                                                        <MDBCol md="12" style={{ fontSize: "14px", display: "table" }}>
                                                            <div className="cartSummaryItem"><b>House & Street Number:</b> {this.state.deliveryStreet}</div>

                                                        </MDBCol>
                                                        <MDBCol md="12" style={{ fontSize: "14px", display: "table" }}>
                                                            <div className="cartSummaryItem"><b>Apartment, Suite etc:</b> {this.state.deliveryApartment}</div>

                                                        </MDBCol>
                                                        <MDBCol md="12" style={{ fontSize: "14px", display: "table" }}>
                                                            <div className="cartSummaryItem"><b>Province:</b> {this.state.selectedProvince}</div>

                                                        </MDBCol>
                                                        <MDBCol md="12" style={{ fontSize: "14px", display: "table" }}>
                                                            <div className="cartSummaryItem"><b>Suburb:</b> {this.state.selectedSuburb.value}</div>

                                                        </MDBCol>
                                                        <MDBCol md="12" style={{ fontSize: "14px", display: "table" }}>
                                                            <div className="cartSummaryItem"><b>Phone:</b> {this.state.deliveryPhone}</div>

                                                        </MDBCol>
                                                        <MDBCol md="12" style={{ fontSize: "14px", display: "table" }}>
                                                            <div className="cartSummaryItem"><b>Message/Instructions:</b> {this.state.deliveryInstructions}</div>

                                                        </MDBCol>
                                                    </div>
                                                ) : (
                                                        <div></div>
                                                    )}

                                                {/*buttons here*/}
                                                {/*{this.getCartButtons(this.state.isExperienceCenter, disableEcCheckout)}*/}

                                            </MDBRow>
                                        </MDBCardText>
                                        <hr className="hr_grey" />
                                        {this.getCartButtons(this.state.isExperienceCenter, disableEcCheckout)}
                                    </MDBCard>


                                    {/* <MDBBtn color="success" rounded className="float-right" onClick={this.handleSubmission}>submit</MDBBtn>
                                {this.getCartButtons(this.state.isExperienceCenter, disableEcCheckout)}*/}
                                </MDBCol>)}

                        </form>
                    </MDBCol>
                    <MDBCol >
                        <div hidden={!this.state.summaryVisible}>
                            <span style={{ fontSize: "16px", fontWeight: "bold", paddingBottom: "3px" }}><MDBIcon icon="file-signature" />&nbsp;{this.state.isExperienceCenter ? 'Summary' : 'Cart Summary'}</span>
                            <MDBCard className="card-body" style={{ marginTop: "1rem", color: Colors.black }}>

                                <MDBCardText>
                                    <MDBRow>
                                        <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                            <div className="cartSummaryItem">Items Total:</div>
                                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.itemsTotal)}</div>
                                        </MDBCol>
                                        <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                            <div className="cartSummaryItem">Delivery Charge:</div>
                                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.deliveryCharge)}</div>
                                        </MDBCol>
                                        <MDBCol sm="12" style={{ fontSize: "14px", display: "table" }}>
                                            <div className="cartSummaryItem"> Fixed Charge:</div>
                                            <div className="text-right cartSummaryItem">{this.formatter.formatCurrency(this.state.cartData.fixedCharge)}</div>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBCardText>
                            </MDBCard>
                        </div>
                    </MDBCol>
                </MDBRow>
                <ToastContainer
                    hideProgressBar={true}
                    newestOnTop={true}
                    autoClose={5000}
                />

                <MDBModal isOpen={this.state.modalOpen} toggle={this.state.modalOpen} centered>
                    <MDBModalHeader>Important</MDBModalHeader>
                    <MDBModalBody>
                        Please do not refresh or close your browser once you have clicked pay now on the payment screen.
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="purple" onClick={this.toggle}>Continue to Payment</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.dirty} toggle={this.state.dirty} centered>
                    <MDBModalHeader>Update Cart</MDBModalHeader>
                    <MDBModalBody>
                        <MDBCol sm="12" className="text-center">
                            <div hidden={!this.state.dirty}>
                                <MDBBtn rounded color="mdb-color" size="sm" onClick={this.resetCart}><MDBIcon icon="sync-alt" />&nbsp;Reset</MDBBtn>
                                <MDBBtn rounded color="pink" size="sm" onClick={this.updateCart}><MDBIcon icon="arrow-up" />&nbsp;Update</MDBBtn><br />
                                <span style={{ color: "black", fontSize: "14px" }}>Cart has changed, please update to checkout. <br />(Items with 0 quantity will be removed.)</span>
                            </div>
                        </MDBCol>
                    </MDBModalBody>

                </MDBModal>

                <MDBModal isOpen={this.state.formModalOpen} toggle={this.state.formModalOpen} centered>
                    <MDBModalHeader>Important</MDBModalHeader>
                    <MDBModalBody>
                        {this.state.modalMsg}
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="purple" onClick={this.toggleFormModal}>ok</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>
            </div>


        );
    }
}



//state = {
//    formActivePanel1: 1,
//    formActivePanel1Changed: false,
//}




//componentWillMount() {
//    //var params = this.getParams(window.location.href)
//}

////    getParams (url) {
////    var params = {};
////    var parser = document.createElement('a');
////    parser.href = url;
////    var query = parser.search.substring(1);
////    var vars = query.split('&');
////    for (var i = 0; i < vars.length; i++) {
////        var pair = vars[i].split('=');
////        params[pair[0]] = decodeURIComponent(pair[1]);
////    }
////    return params;
////};

//async CallTransaction() {
//    //alert('Call Transaction')
//    //var object = {
//    //    "apiKey": "f9bd07c6-a662-441c-8335-365a967cf1b3",
//    //    "merchantOrderNumber": "MON123456",
//    //    "amount": "12300",
//    //    //"validationURL": "http://test.co.za/validate",
//    //    "description": "Test Transaction"
//    //}
//    //let response = await axios.post('https://sandbox.ms.fnb.co.za/eCommerce/v2/prepareTransaction', object);
//    //console.log('Response');
//    //console.log(response);
//    //window.location.assign('https://www.google.com');
//    //https://sa.api.fastway.org/v3/docs/detail?ControllerName=psc&ActionName=lookup&api_key=54b545010fd070c89cd5e0aa2646769e 

//    //let response = await axios.get('https://sa.api.fastway.org/v3/psc/suburbsinregion/JNB?api_key=54b545010fd070c89cd5e0aa2646769e');
//    //let test = "";

//    //let responseII = await axios.get('https://sa.api.fastway.org/v3/psc/lookup/CPT/Doringkloof/0157/5?api_key=54b545010fd070c89cd5e0aa2646769e');
//    //let testII = "";

//    //let responseIII = await axios.get('https://sa.api.fastway.org/v3/psc/listrfs?CountryCode=24&api_key=54b545010fd070c89cd5e0aa2646769e')
//    //let testIII = "";

//    //get a list of all suburbs with province
//    //let responseIII = await axios.get('https://api.siteway.co.za/fastway/woo/v1/find-suburb-province-all/');
//}